export default __webpack_public_path__ + "static/media/marketting-email-icon.366fe3f6.svg";